// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__2nIst","assignButton":"CreateEditEquipmentSchedule_assignButton__1qavY"};